/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum OrgType {
  personal = 'personal',
  group = 'group'
}
